jQuery( window ).on('load', function($) {
  //console.log("The page has loaded.");
});